import React, { useState, useEffect } from 'react';
import Lottie from 'react-lottie-player';

const DoGoodTextAnimation = () => {
  const [animationData, setAnimationData] = useState();

  useEffect(() => {
    import('../../assets/lottie/DoGoodRealmText.json').then(setAnimationData);
  }, []);

  if (!animationData) return <div className="realm" />;
  return (
    <Lottie
      animationData={animationData}
      background="transparent"
      play
      speed={1}
      loop={false}
      className="text dogood"
    />
  );
};

export default React.memo(DoGoodTextAnimation);
